// removed by extract-text-webpack-plugin
module.exports = {"button":"theme__button___1JX1S","primary":"theme__primary___3JAMN","floating":"theme__floating___2oje-","fadeUp":"theme__fadeUp___2tTZV","lateFadeUp":"theme__lateFadeUp___3WOHc","lateFadeIn":"theme__lateFadeIn___1X_mu"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/user/components/StartOver/theme.scss
// module id = 1258
// module chunks = 0